import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { ASSETS, openOrder } from "../../data/site";

const LINKS = [
  { label: "Menu", id: "menu" },
  { label: "Our Story", id: "story" },
  { label: "Shakes", id: "shakes" },
  { label: "Locations", id: "locations" },
  { label: "Gallery", id: "gallery" },
];

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-white/85 backdrop-blur-xl shadow-[0_10px_30px_-18px_rgba(246,60,139,0.5)]" : "bg-transparent"
      }`}
    >
      <nav className="max-w-[1400px] mx-auto px-5 sm:px-8 h-[84px] flex items-center justify-between">
        <button data-testid="logo-home" onClick={() => scrollTo("hero")} className="flex items-center gap-3 group">
          <img src={ASSETS.logoRed} alt="Rock N Roll Hand Rolled Premium Ice Cream logo"
            className="h-16 w-16 sm:h-[76px] sm:w-[76px] object-contain transition-transform duration-500 group-hover:rotate-[10deg]" />
          <span className="font-display text-xl sm:text-2xl leading-none text-[#F63C8B]">
            Rock<span className="text-[#12B99B]"> N </span>Roll
          </span>
        </button>

        <div className="hidden lg:flex items-center gap-9">
          {LINKS.map((l) => (
            <button key={l.id} data-testid={`nav-${l.id}`} onClick={() => scrollTo(l.id)}
              className="link-underline text-sm font-semibold text-[#3A2A32] hover:text-[#F63C8B] transition-colors">
              {l.label}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <button onClick={openOrder} data-testid="nav-order-online"
            className="btn-primary hidden sm:inline-flex items-center px-7 py-3 text-xs font-bold uppercase tracking-[0.12em]">
            Order Online
          </button>
          <button data-testid="mobile-menu-toggle" className="lg:hidden p-2 text-[#2A1620]"
            onClick={() => setOpen((v) => !v)} aria-label="Toggle menu">
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
            className="lg:hidden overflow-hidden bg-white/95 backdrop-blur-xl border-t border-[#F8DCE7]">
            <div className="px-6 py-6 flex flex-col gap-4">
              {LINKS.map((l) => (
                <button key={l.id} data-testid={`mobile-nav-${l.id}`} onClick={() => { scrollTo(l.id); setOpen(false); }}
                  className="text-left font-display text-2xl text-[#2A1620]">{l.label}</button>
              ))}
              <button onClick={() => { openOrder(); setOpen(false); }} data-testid="mobile-nav-order-online"
                className="btn-primary mt-2 text-center px-6 py-3 text-sm font-bold uppercase tracking-[0.12em]">Order Online</button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
